export const ROUTES = {
  START_TRIAL: '/account-plans/trial',
  REQUEST_PAID: '/account-plans/request-paid',
};

export const REDUCER_PATH = 'accountPlanApi';
